/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Check_New_ReviewInputs */

const en_cv_check_new_review = /** @type {(inputs: Cv_Check_New_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review new resume`)
};

const de_cv_check_new_review = /** @type {(inputs: Cv_Check_New_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuen Lebenslauf prüfen`)
};

/**
* | output |
* | --- |
* | "Review new resume" |
*
* @param {Cv_Check_New_ReviewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cv_check_new_review = /** @type {((inputs?: Cv_Check_New_ReviewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Check_New_ReviewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_check_new_review(inputs)
	return en_cv_check_new_review(inputs)
});